import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('hyperlink')
@Component({
    selector: 'app-hyperlink',
    templateUrl: './hyperlink.component.html',
    styleUrls: ['./hyperlink.component.scss'],
    standalone: false
})
export class HyperlinkComponent extends FormEntryComponentClass implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() { }
}
